import { Constant } from '../../../const';

const variableScope = [
  Constant.k.SCOPE_APPLICATION,
  Constant.k.SCOPE_MODULE
].join('|');

export { variableScope };
